import DateFilter from "../../../components/rangePicker/rangePicker";
import {
	updateFiltersDate,
	getDynFilterValues,
	setKeyFilterSelected,
} from "../../../redux/actions/visitActions";
import connect from "react-redux/es/connect/connect";

const mapStateToProps = (state, ownProps) => {
	return {
		currentFilters: state.visit.currentFilters
			? state.visit.currentFilters[ownProps.filterTargetKey]
			: [],
		minDate:
			state.visit.filters && state.visit.filters.period
				? state.visit.filters.period[0]
				: null,
		maxDate:
			state.visit.filters && state.visit.filters.period
				? state.visit.filters.period[1]
				: null,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		addFilter: values => {
			dispatch(updateFiltersDate(ownProps.filterTargetKey, values));
		},
		getDynFilterValues: () => dispatch(getDynFilterValues()),
		setKeyFilterSelected: () =>
			dispatch(setKeyFilterSelected(ownProps.filterTargetKey)),
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(DateFilter);



// WEBPACK FOOTER //
// src/containers/activite/visit/DateFilterContainer.js